import { ModuleId } from '@/types/team';

export interface DiscoveryItem {
    id: string;
    title: string;
    description: string;
    image?: string; // Optional illustration path or unicode emoji
    route?: string; // If allowing deep link
    actionLabel?: string; // e.g., "Take me there"
    requiredModule?: ModuleId; // Link to team.show_[module]_module
    minRole?: 'admin' | 'member'; // Optional role restriction
}

export const DISCOVERY_ITEMS: DiscoveryItem[] = [
    {
        id: 'fyp_intro',
        title: 'Nieuw: Voor Jou Pagina',
        description: 'Een persoonlijk overzicht van jouw taken en voortgang. Hier zie je in één oogopslag wat je vandaag moet doen.',
        requiredModule: 'fyp',
        actionLabel: 'Bekijk nu',
        image: '👤'
    },
    {
        id: 'stock_intro',
        title: 'Voorraadbeheer',
        description: 'Houd je voorraad bij en voeg automatisch producten toe aan je boodschappenlijstje als ze bijna op zijn.',
        requiredModule: 'stock',
        actionLabel: 'Naar voorraad',
        image: '📦'
    }
];
